import { useEffect, useState } from "react";
import { api } from "./api.js";
import { useNavigate } from "react-router-dom";
import { funnel } from "./funnel.js";

/** Cennik z backendu. Zwraca też stan ładowania i ewentualny błąd sieci. */
export function useServices() {
  const [services, setServices] = useState([]);
  const [state, setState] = useState("loading"); // loading | ready | error

  useEffect(() => {
    let alive = true;
    api("/services")
      .then((d) => {
        if (!alive) return;
        setServices(Array.isArray(d) ? d : []);
        setState("ready");
      })
      .catch(() => alive && setState("error"));
    return () => {
      alive = false;
    };
  }, []);

  return { services, state };
}

/** Lista prawników do pokazania klientowi (formularz zamówienia) — tylko
    dane bezpieczne publicznie (patrz GET /api/lawyers-public). */
export function useLawyersPublic() {
  const [lawyers, setLawyers] = useState([]);

  useEffect(() => {
    let alive = true;
    api("/lawyers-public")
      .then((d) => alive && setLawyers(Array.isArray(d) ? d : []))
      .catch(() => {}); // brak listy nie może zablokować formularza zamówienia
    return () => {
      alive = false;
    };
  }, []);

  return lawyers;
}

/** Klik „Zamów” — zawsze prosto do formularza zamówienia; logowanie albo
    założenie konta dzieje się tam, przy składaniu zamówienia (NewCase.jsx),
    a nie jako osobna ściana przed formularzem. */
export function useOrder() {
  const nav = useNavigate();
  return (svc) => {
    funnel("site_cta", { where: "service" });
    nav("/panel/nowa", { state: { serviceId: svc?.id } });
  };
}
